import { render, staticRenderFns } from "./_algoliaUserList.vue?vue&type=template&id=a7927186"
import script from "./_algoliaUserList.vue?vue&type=script&lang=js"
export * from "./_algoliaUserList.vue?vue&type=script&lang=js"
import style0 from "./_algoliaUserList.vue?vue&type=style&index=0&id=a7927186&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports